
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.001 16.886a9.31 9.31 0 01-6.68-3.247 15.176 15.176 0 01-1.677-2.145c-.169-.263-.3-.489-.401-.66l-.07-.128c-.022-.04-.04-.075-.055-.099a.365.365 0 01-.05-.111v-.001l-.005.002a1.052 1.052 0 01-.021-.952.341.341 0 01.018-.044.362.362 0 01.058-.108c.015-.024.033-.059.054-.099l.038-.07.037-.064c.1-.172.23-.395.396-.653a15.196 15.196 0 011.68-2.148A9.308 9.308 0 0110 3.114a9.304 9.304 0 016.68 3.247 15.3 15.3 0 011.678 2.145c.16.25.287.467.386.636l.043.073c.002.005.038.07.04.076.022.041.04.078.057.102a.382.382 0 01.048.105l.006.015.005-.002a1.116 1.116 0 01.118.496 1.06 1.06 0 01-.1.442.306.306 0 01-.017.043 1.176 1.176 0 01-.023.044.376.376 0 01-.037.071c-.016.024-.035.06-.057.102l-.034.065-.045.078c-.099.17-.227.388-.39.64a15.244 15.244 0 01-1.68 2.149 9.303 9.303 0 01-6.678 3.245zM1.87 10.468c.097.166.223.382.384.634a14.463 14.463 0 001.597 2.042A8.61 8.61 0 0010 16.16a8.607 8.607 0 006.15-3.016 14.532 14.532 0 001.6-2.044c.154-.242.277-.452.372-.615l.04-.067c.048-.093.078-.148.102-.187l.015-.032a.276.276 0 01.015-.036.352.352 0 00.042-.157.388.388 0 00-.042-.17l-.013-.032a.46.46 0 01-.021-.044c-.022-.036-.046-.08-.073-.13l-.069-.123c-.095-.162-.216-.37-.37-.61a14.528 14.528 0 00-1.597-2.042 8.604 8.604 0 00-6.15-3.017 8.607 8.607 0 00-6.15 3.016 14.485 14.485 0 00-1.6 2.044c-.158.247-.283.462-.378.626l-.062.11a2.638 2.638 0 01-.074.134l-.017.034a.317.317 0 01-.019.042.333.333 0 000 .31.44.44 0 01.016.035.624.624 0 01.03.057l.064.118m17.123.127zm-.316-.159zm-8.618 2.929A3.262 3.262 0 1113.263 10a3.265 3.265 0 01-3.262 3.262zm0-5.799A2.537 2.537 0 1012.538 10a2.54 2.54 0 00-2.537-2.537z"}})])
          )
        }
      }
    